/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Ability } from "@casl/ability";
import App from "App";
import "./style.css"

// Material Dashboard 2 PRO React Context Provider
import { MaterialUIControllerProvider, AuthContextProvider } from "context";
import { AbilityContext } from "Can";
import { WebSocketProvider } from "context/WebSocketContext";
import { APIProvider } from "@vis.gl/react-google-maps";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./error";

const container = document.getElementById("root");
const root = createRoot(container);
const ability = new Ability();
root.render(
  <AbilityContext.Provider value={ability}>
    <WebSocketProvider>
      <BrowserRouter>
        <AuthContextProvider>
          <MaterialUIControllerProvider>
            <APIProvider apiKey={process.env.REACT_APP_MAP_API_KEY} libraries={['marker', 'drawing', 'geometry', 'places']} >
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => window.location.reload()}
              >
                <App ability={ability} />
              </ErrorBoundary>
            </APIProvider>
          </MaterialUIControllerProvider>
        </AuthContextProvider>
      </BrowserRouter>
    </WebSocketProvider>
  </AbilityContext.Provider>
);
